import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyle: CSSProperties = {
  position: 'absolute',
  width: '100%',
  height: 'calc(100vh - 180px)',
  marginTop: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  touchAction: 'none',
  background: 'transparent',
  overflow: 'hidden'
};

export const contentStyle: CSSProperties = {
  width: 'calc(100% - 25px)',
  height: 'calc(100% - 25px)',
  background: UIConfig.Card.Content.background,
  borderRadius: UIConfig.Card.Content.borderRadius,
  position: 'relative',
  marginTop: '0px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden'
};